// extracted by mini-css-extract-plugin
module.exports = {"loadingOverlay":"Loading_loadingOverlay__1JCGO","loadingCard":"Loading_loadingCard__3SgH7","loadingSpinner":"Loading_loadingSpinner__S0-s3"};